// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uploaded-document-pdf{text-align:center;height:65vh;display:flex;flex-direction:column}.uploaded-document-pdf .content-container{flex:1;overflow:visible;display:flex;justify-content:center;align-items:center}.uploaded-document-pdf__image{max-width:90%;max-height:100%;object-fit:contain}.uploaded-document-pdf__embed{width:90%;height:100%;border:none;overflow:auto}.uploaded-document-pdf__open-button{text-align:center;display:block;padding:10px 0;flex-shrink:0}", ""]);
// Exports
module.exports = exports;
